<template>
  <div>
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="false"
        :v-on:update:title="(isLoading = false)"
      />
    </div>
    <horizontal-stepper
      locale="pt"
      v-if="steps != null"
      :steps="steps"
      :keep-alive="false"
      :reset="true"
      @stepper-finished="finalizar"
      @completed-step="completeStep"
      @active-step="isStepActive"
    />
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import axios from "axios";
import * as config from "@/config.json";
import HorizontalStepper from "@/horizontal-stepper";

// Steps
import VincularPromocao from "./steps/1_VincularPromocao";
import ImagemPromocao from "./steps/2_ImagemPromocao";
import ImagemJornalzinho from "./steps/2_ImagemJornalzinho";
import ProdutosPromocao from "./steps/3_ProdutosPromocao";
import ConfigurarPromocao from "./steps/4_ConfigurarPromocao";
import store from "../../store";

export default {
  name: "inserir-promocoes",

  components: {
    Loading,
    HorizontalStepper,
    VincularPromocao,
    ImagemPromocao,
    ProdutosPromocao,
    ConfigurarPromocao,
  },
  data: function () {
    return {
      isLoading: false,
      titulo: null,
      descricao: null,
      isjornalzinho: null,
      steps: null,
      qtdePaginas: null,
      store,
    };
  },
  watch: {},
  methods: {
    rowHandler(record) {
      localStorage.setItem("cod_promocao", record.codigo);
      localStorage.setItem("data_inicial", record.data_inicial);
      localStorage.setItem("data_final", record.data_final);
      this.$router.push({ path: `inserir-promocao/${record.codigo}` });
    },
    goBack() {
      this.$router.go(-1);
    },

    // Executed when @completed-step event is triggered
    completeStep(payload) {
      this.isLoading = true;
      this.steps.forEach((step) => {
        if (step.name === payload.name) {
          step.completed = true;
        }
      });
    },
    // Executed when @active-step event is triggered
    isStepActive(payload) {
      this.steps.forEach((step) => {
        if (step.name === payload.name) {
          if (step.completed === true) {
            step.completed = false;
          }
        }
      });
    },
    trataImagens() {
      return this.store.imagemJornal.map((image) => image.imagem);
    },
    removeImagens() {
      for (let i = 1; i <= this.qtdePaginas; i++) {
        sessionStorage.removeItem(`image-${i}`);
      }
    },
    limpaDadosPush() {
      localStorage.removeItem("tituloPromocao");
      localStorage.removeItem("descricaoPromocao");
      localStorage.removeItem("chamadaCampanha");
    },

    limpaLocalStorage() {
      this.isjornalzinho == 1
        ? this.removeImagens()
        : localStorage.removeItem("image");
      localStorage.removeItem("jornalzinho");
      localStorage.removeItem("selecionado");
      localStorage.removeItem("titulo");
      localStorage.removeItem("descricao");
      localStorage.removeItem("data_inicial");
      localStorage.removeItem("data_final");
    },

    async finalizar() {
      this.isLoading = true;
      var havepush = localStorage.getItem("have-push");
      const url = `${config.default.servidor}/gerencial/${
        this.isjornalzinho === 1 ? "jornalzinho" : "promocao"
      }`;

      try {
        const response = await axios({
          url,
          method: "put",
          data: {
            empresaid: localStorage.getItem("enterprise_id"),
            cnpj: localStorage.getItem("cnpj"),
            promocaoid_local: localStorage.getItem("selecionado"),
            titulo: localStorage.getItem("titulo"),
            descricao: localStorage.getItem("descricao"),
            imagem:
              this.isjornalzinho == 1
                ? this.trataImagens()
                : localStorage.getItem("image"),
            data_inicial: localStorage.getItem("data_inicial").toString(),
            data_final: localStorage.getItem("data_final").toString(),
            showText: localStorage.getItem("show-text"),
          },
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          this.isLoading = false;
          store.limpaStore();

          await this.$alert("Promoção vinculada!", "Sucesso", "success");

          if (havepush == "true") {
            localStorage.setItem("redirectid", response.data.cod_promocao);
            localStorage.setItem("tipoid", this.isjornalzinho == 1 ? "1" : "2");
            localStorage.setItem("chamadaCampanha", "Promocao");
            localStorage.setItem(
              "tituloPromocao",
              localStorage.getItem("titulo")
            );
            localStorage.setItem(
              "descricaoPromocao",
              localStorage.getItem("descricao")
            );
            this.$router.push({ path: `/cadastrar-campanha` });
          } else {
            this.$router.push({ path: `/promocoes` });
          }
        }

        this.limpaLocalStorage();
      } catch (error) {
        this.isLoading = false;
        this.$alert("Falha no vínculo da promoção!", "Erro", "error");
        console.log({ error });
      }
    },
  },

  beforeMount() {
    this.isLoading = true;
    this.isjornalzinho = Number(localStorage.getItem("jornalzinho"));
    this.limpaDadosPush();
    this.steps = [
      {
        icon: "assignment",
        name: "vincular-promocao",
        title:
          this.isjornalzinho == 1 ? "Vincular ao Jornal" : "Vincular Promoção",
        component: VincularPromocao,
      },
      {
        icon: "photo",
        name: "vincular-imagem",
        title: this.isjornalzinho == 1 ? "Vincular Imagens" : "Vincular Imagem",
        component: this.isjornalzinho == 1 ? ImagemJornalzinho : ImagemPromocao,
      },
      {
        icon: "collections",
        name: "editar-produtos",
        title: "Editar Produtos",
        component: ProdutosPromocao,
      },
      {
        icon: "check_box",
        name: "finalizar",
        title: "Finalizar",
        component: ConfigurarPromocao,
      },
    ];
    this.isLoading = false;
  },
};
</script>
<style>
.animated {
  -webkit-animation-duration: 0s !important;
  animation-duration: 0s !important;
}
</style>